module.exports = __webpack_public_path__ + "resources/img/img_confluent_platform2.389c1db275572d599554029b1002cc89.png";